import React, { useEffect, useMemo, createElement } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useSurveyModal } from '../../hooks/use-survey-modal';
const BOOKING_BASE_URL = 'https://admin.thehireadvantage.co/widget/booking/WleXgzSPd8KJ0dm0EXQn';
export function SurveyModal() {
  const {
    isOpen,
    close
  } = useSurveyModal();
  // Build iframe URL with contact params from the page URL
  const iframeSrc = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const contactParams = new URLSearchParams();
    const firstName = params.get('contact.first_name') || params.get('first_name');
    const lastName = params.get('contact.last_name') || params.get('last_name');
    const email = params.get('contact.email') || params.get('email');
    const phone = params.get('contact.phone') || params.get('phone_number') || params.get('phone');
    if (firstName) contactParams.set('first_name', firstName);
    if (lastName) contactParams.set('last_name', lastName);
    if (email) contactParams.set('email', email);
    if (phone) contactParams.set('phone', phone);
    const queryString = contactParams.toString();
    return queryString ? `${BOOKING_BASE_URL}?${queryString}` : BOOKING_BASE_URL;
  }, []);
  // Load the embed script once
  useEffect(() => {
    if (document.getElementById('hire-advantage-form-script')) return;
    const script = document.createElement('script');
    script.src = 'https://admin.thehireadvantage.co/js/form_embed.js';
    script.async = true;
    script.id = 'hire-advantage-form-script';
    document.body.appendChild(script);
  }, []);
  // Close on Escape key
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    if (isOpen) document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, close]);
  // Prevent body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-785">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6" style={{
      backgroundColor: 'rgba(0,0,0,0.82)'
    }} onClick={e => {
      if (e.target === e.currentTarget) close();
    }} data-id="element-786">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 16
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col" style={{
        border: '1px solid rgba(78,205,196,0.3)',
        maxHeight: 'calc(100dvh - 2rem)'
      }} data-id="element-787">
            {/* Close button */}
            <button onClick={close} className="absolute top-3 right-3 w-8 h-8 rounded-full bg-black/10 hover:bg-black/20 flex items-center justify-center transition-colors z-10" aria-label="Close" data-id="element-788">
              <XIcon className="w-4 h-4 text-gray-600" data-id="element-789" />
            </button>

            {/* Iframe — takes full space, no header/footer clutter */}
            <div className="w-full bg-white flex-1 min-h-0 overflow-y-auto rounded-2xl" data-id="element-790">
              <iframe src={iframeSrc} style={{
            border: 'none',
            width: '100%',
            height: '100%',
            minHeight: '700px',
            display: 'block'
          }} id="g1yzmQ5zrcbQymQN101p_1775098372877" title="Book a Call" data-id="element-791" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}